"use client";

import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryStreamedHydration } from "@tanstack/react-query-next-experimental";
import { Suspense } from "react";
import { Toaster } from "@/shared/components/ui/sonner";
import { RouteTelemetry } from "@/shared/observability/RouteTelemetry";
import { getQueryClient } from "@/shared/query-client";
import { ThemeProvider } from "./ThemeProvider";

/**
 * Root client providers, GLOBAL to every route: theme → query → streamed
 * hydration → toaster. AuthProvider is intentionally NOT here — it reads
 * session state that can't be statically prerendered, so it's scoped to the
 * authenticated (app)/(admin) subtrees (which are request-time dynamic). This
 * keeps marketing + auth pages fully static-capable.
 */
export function Providers({ children }: { children: React.ReactNode }) {
  const queryClient = getQueryClient();
  return (
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <ReactQueryStreamedHydration>
          <Suspense fallback={null}>
            <RouteTelemetry />
          </Suspense>
          {children}
          <Toaster />
        </ReactQueryStreamedHydration>
      </QueryClientProvider>
    </ThemeProvider>
  );
}
